import { useRouteMatch, Switch, Route } from "react-router";
import PhysicalHealth from "./PhysicalHealth";
import { EligibilityCheckerQuestionsProps, ProgrammeProps } from "../Props";
import { HealthConditionDetails } from "../../../../types/ProfileViewModel";
import { PowerOfTen, ProgressStepEnum, setStepProgress } from "../../../../redux/slices/progressBarSlice";
import { useDispatch } from "react-redux";
import { useEffect } from "react";

export interface PhysicalHealthPageData {
  questions: EligibilityCheckerQuestionsProps[];
}

export interface PhysicalHealthProps extends ProgrammeProps {
  physicalHealthPageData: PhysicalHealthPageData;
  nextStepUrl: string;
  healthConditions?: HealthConditionDetails;
}

function PhysicalHealthRoot({
  programmeTitle,
  physicalHealthPageData,
  nextStepUrl,
  healthConditions,
  progressPercentage,
}: Readonly<PhysicalHealthProps & { progressPercentage?: PowerOfTen }>) {
  let { path } = useRouteMatch();
  const dispatch = useDispatch();

  useEffect(() => {
    if (progressPercentage) {
      dispatch(
        setStepProgress({
          progressStepEnum: ProgressStepEnum.CheckEligiblity,
          progressPercentage: progressPercentage,
        })
      );
    }
  }, [dispatch, progressPercentage]);

  return (
    <Switch>
      <Route exact path={`${path}`}>
        <PhysicalHealth
          healthConditions={healthConditions}
          programmeTitle={programmeTitle}
          physicalHealthPageData={physicalHealthPageData}
          nextStepUrl={nextStepUrl}
        />
      </Route>
    </Switch>
  );
}

export default PhysicalHealthRoot;
